import AccordionItem from './AccordionItem'
import parse from 'html-react-parser'

const PDPAccordion = ({ desc, valueProps, nogots, age }) => {
    // console.log('nogots', nogots)

    return (
        <div className="accordion-outer">
            <div className="accordion-inner">
                <ul className="accordion-list nostyle">
                    {desc && (
                        <AccordionItem
                            itemData={desc}
                            key="product-details-00"
                            type="desc"
                            nogots={nogots}
                            age={age}
                        />
                    )}
                    {valueProps &&
                        valueProps.map((item, index) => {
                            return (
                                <AccordionItem
                                    itemData={item}
                                    key={index}
                                    index={index}
                                    type="valueProp"
                                />
                            )
                        })}
                </ul>
            </div>
        </div>
    )
}

export default PDPAccordion
